<template>
    <div>
        <loader :show="enviando"/>
        <v-card class="elevation-10">
            <v-toolbar >
                <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
                <v-card-title><h3>Agregar personal</h3></v-card-title>
            </v-toolbar>
        <v-card-title>
          <v-container grid-list-md text-xs-center>
            <v-layout row wrap>
              <v-flex xs12 sm4 md3>
                <v-text-field
                  v-model="codigo"
                  :error-messages="codigoErrors"
                  label="Código"
                  required
                  @input="$v.codigo.$touch()"
                  @blur="$v.codigo.$touch()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md3>
                <v-text-field
                  v-model="paterno"
                  :error-messages="paternoErrors"
                  label="Paterno"
                  required
                  @input="$v.paterno.$touch()"
                  @blur="$v.paterno.$touch()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md3>
                <v-text-field
                  v-model="materno"
                  label="Materno"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md3>
                <v-text-field
                  v-model="nombre"
                  :error-messages="nombreErrors"
                  label="Nombre"
                  required
                  @input="$v.nombre.$touch()"
                  @blur="$v.nombre.$touch()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-text-field
                  v-model="curp"
                  :error-messages="curpErrors"
                  label="CURP"
                  :counter="18"
                  required
                  @blur="$v.curp.$touch()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-text-field
                  v-model="rfc"
                  label="RFC"
                  :counter="13"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-title>
        <v-card-actions>
          <v-btn small color="primary" @click="guardar()">Agregar</v-btn>
          <v-btn small color="normal" @click="$router.go(-1)">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from '../../components/Loader'
import axios from 'axios'
import moment from 'moment'

import { validationMixin } from 'vuelidate'
import { required, minLength, email } from 'vuelidate/lib/validators'

export default {
    name: 'AgregarPersonal',
    mixins: [validationMixin],
    components: {
          Loader,
    },
    computed: {
      ...mapGetters([
          "sessionToken",
          "httpURL",
          "userId",
          "tableProps"
      ]),
      codigoErrors () {
        const errors = []
        if (!this.$v.codigo.$dirty) return errors
        !this.$v.codigo.minLength && errors.push('Mínimo 4 caracteres.')
        !this.$v.codigo.required && errors.push('Campo requerido.')
        return errors
      },
      paternoErrors () {
        const errors = []
        if (!this.$v.paterno.$dirty) return errors
        !this.$v.paterno.required && errors.push('Campo requerido.')
        return errors
      },
      // maternoErrors () {
      //   const errors = []
      //   if (!this.$v.materno.$dirty) return errors
      //   !this.$v.materno.required && errors.push('Campo requerido.')
      //   return errors
      // },
      nombreErrors () {
        const errors = []
        if (!this.$v.nombre.$dirty) return errors
        !this.$v.nombre.required && errors.push('Campo requerido.')
        return errors
      },
      curpErrors () {
        const errors = []
        if (!this.$v.curp.$dirty) return errors
        !this.$v.curp.minLength && errors.push('Mínimo 18 caracteres.')
        !this.$v.curp.required && errors.push('Campo requerido.')
        return errors
      },
      // rfcErrors () {
      //   const errors = []
      //   if (!this.$v.rfc.$dirty) return errors
      //   !this.$v.rfc.minLength && errors.push('Mínimo 18 caracteres.')
      //   !this.$v.rfc.required && errors.push('Campo requerido.')
      //   return errors
      // },
    },
    validations: {
      codigo: { required, minLength: minLength(4) },
      paterno: { required },
      // materno: { required },
      nombre: { required },
      curp: { required, minLength: minLength(18) },
      // rfc: { required },
    },
    data() {
        return {
            enviando:false,
            buscar:'',
            codigo: null,
            paterno: null,
            materno: null,
            nombre: null,
            curp: null,
            rfc: null
        }
    },
    methods:{
      guardar(){
        this.$v.$touch();
        if( !this.$v.$invalid ){
          this.enviando = true;
          axios.post(this.httpURL+'/personal/agregar',
            { codigo: this.codigo,
              nombre: this.nombre,
              paterno: this.paterno,
              materno: this.materno,
              curp: this.curp,
              rfc: this.rfc
            },
            {headers:{token: this.sessionToken}})
            .then(res => {
                this.codigo = null;
                this.paterno = null;
                this.materno = null;
                this.nombre = null;
                this.curp = null;
                this.rfc = null;
                this.nombre = null;
                this.enviando = false;
                this.$v.$reset();
                this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
                // console.log(error);
                this.enviando = false;
                this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
            });
        }
      }
    }
    
}
</script>